import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as services from "../../store/service";
import CCAMEnroll from "./CCAMEnroll";
import { DialogComponent } from "../common/DialogComponent";
import IDFCreditAuthentication from "../Credit/Auth/IDFCreditAuthentication";
import { ICSIDUserStatus } from "../../store/csid/types";
import { useTranslation } from "react-i18next";

const ChildCreditActivityMonitoring = (props: any) => {
    const dispatch = useDispatch();
    const { t: tLang } = useTranslation();

    const childrenList = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userInfo?.childrenList ? state.loggedInUser.userInfo?.childrenList : []
    );
    const failedChildrenList = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userInfo?.failedChildrenList ? state.loggedInUser.userInfo?.failedChildrenList : []
    );
    const monitoredChildCount = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userInfo?.numChildrenMonitored ? state.loggedInUser.userInfo?.numChildrenMonitored : 0
    );
    const isChildEnrollmentAllowed = useSelector((state: ApplicationState) =>
        state.childMonitoringServiceState && state.childMonitoringServiceState.isChildEnrollmentAllowed
            ? state.childMonitoringServiceState.isChildEnrollmentAllowed
            : false
    );

    const loggedInActiveAccountID = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activeAccount ? state.loggedInUser.activeAccount.subcustomerId : null
    );

    const [isLoading, setIsLoading] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [isParentL3Failed, setIsParentL3Failed] = useState(false);
    const [L3StatusData, setL3StatusData] = useState({});
    const [showAuthenticationDialog, setShowAuthenticationDialog] = useState(false);

    const closeTuIdfAuthDialog = (): any => {
        setShowAuthenticationDialog(false);
        updateL3Status();
    };
    useEffect(() => {
        updateL3Status();
    }, []);

    useEffect(() => {
        validateChildCount(false);
    }, [loggedInActiveAccountID]);

    const updateL3Status = () => {
        setIsLoading(true);
        services
            .GetParentL3Status()
            .then((data) => {
                if (data && data["auth-status"]) {
                    setL3StatusData(data);
                    setIsActive(data["auth-status"] === "authenticated" ? true : false);

                    const isL3Failed =
                        data["auth-status"]?.toLocaleLowerCase() === "locked" || data["auth-status"]?.toLocaleLowerCase() === "locked-not-enough-info" ||  data["auth-status"]?.toLocaleLowerCase() === "l3-otp-locked" ;
                    setIsParentL3Failed(isL3Failed);
                }
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
            });
    };

    const validateChildCount = (formSubmit: boolean) => {
        if (monitoredChildCount >= 10) {
            let isMatch = false;

            childrenList.forEach((child: any) => {
                if (child.subAccountPk === loggedInActiveAccountID) {
                    isMatch = true;
                }
            });

            if (!isMatch) {
                dispatch({ type: "SET_IS_CHILD_ENROLLMENT_ALLOWED", isChildEnrollmentAllowed: false });
            }
            // if submitting 11th child through the form
            // if (formSubmit) {
            //     failedChildrenList.forEach((child: any) => {
            //         if (child.id === loggedInActiveAccountID) {
            //             setIsLoading(false);
            //             dispatch({ type: "SET_IS_CHILD_ENROLLMENT_ALLOWED", isChildEnrollmentAllowed: false });
            //         }
            //     });
            // } else {
            //     // if form has already been submitted with 11th child error
            //     if (failedChildrenList && failedChildrenList.length > 0) {
            //         let isMatch = false;

            //         childrenList.forEach((child: any) => {
            //             if (child.subAccountPk === loggedInActiveAccountID) {
            //                 isMatch = true;
            //             }
            //         })

            //         if (!isMatch) {
            //             dispatch({ type: "SET_IS_CHILD_ENROLLMENT_ALLOWED", isChildEnrollmentAllowed: false });
            //         }
            //     // @TODO add logic here to handle logout case where failedChildrenList state is lost
            //     } else {
            //         // can we add (errorResponse: "CCAM_CHILDREN_LIMIT_EXCEEDED") to `GetChildMonitoringStatusAsync` API once user has received the error the 1st time
            //     }
            // }
        }
    };

    return (
        <React.Fragment>
            {/*<!-- Page Content -->*/}
            <div className={`box offset-padding ${isLoading ? "loading" : ""}`}>
                <div className="box-header">
                    <div className="box-title-container">
                        <div className="box-title-icon" aria-hidden="true">
                            <em className="las la-list"></em>
                        </div>
                        <div className="box-title-text has-actions">
                            <h2 className="box-title">Child Credit Activity Monitoring</h2>
                        </div>
                    </div>

                    <div className="box-description">
                        <p>
                            Safeguard your child from identity threats. Find peace of mind that you are being notified of credit activity related to your child's
                            SSN.
                        </p>
                    </div>
                    <div>
                        {!isLoading && !isChildEnrollmentAllowed ? (
                            <p>
                                {tLang("credit.creditActivity.code550ErrorMsg")}
                            </p>
                        ) : (
                            <>
                                {!isLoading && !isActive && !isParentL3Failed && (
                                    <div className="data-grid" role="grid" style={{ backgroundColor: "#F2F6F9", width: "100%", padding: "10px" }}>
                                        <div className="box-header col-xs-12 col-sm-12 ">
                                            <div className="content-sub-title text-align-center">
                                                <div className="monitoring-alert-icon" style={{ fontSize: "40px" }}>
                                                    <em className="las la-exclamation-circle "></em>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="box-content text-align-center margin-bottom-s">
                                            <p>To add credit activity monitoring for your child,</p>
                                            <p>Please authenticate your identity</p>
                                            <button type="submit" className="btn-default btn-primary" onClick={() => setShowAuthenticationDialog(true)}>
                                                <span className="btn-text">Authenticate</span>
                                            </button>
                                        </div>
                                    </div>
                                )}
                                {!isLoading && isParentL3Failed && (
                                    <IDFCreditAuthentication
                                        initCSIDUserStatus={L3StatusData as ICSIDUserStatus}
                                        creditAuthCallback={closeTuIdfAuthDialog}
                                        displayFlowAsDialog={true}
                                    />
                                )}
                                {!isLoading && isActive && (
                                    <>
                                        <div className="form-row inline row">
                                            <div className="form-label col-xs-12 col-sm-12 col-no-gutter margin-bottom-s">
                                                <div className="line-divider"></div>
                                            </div>
                                        </div>
                                        <CCAMEnroll updateActivityDetected={props.updateActivityDetected} validateChildCount={validateChildCount} />
                                    </>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
            {showAuthenticationDialog && (
                <DialogComponent dialogId="dialog-tu-idf-auth" title="TU-IDF L3 Auth" closeDialog={closeTuIdfAuthDialog} hideCloseButton={true}>
                    <IDFCreditAuthentication
                        initCSIDUserStatus={L3StatusData as ICSIDUserStatus}
                        creditAuthCallback={closeTuIdfAuthDialog}
                        displayFlowAsDialog={false}
                    />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default ChildCreditActivityMonitoring;
